/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

// here we apply our font css
import './src/styles/fonts.css'
// apply our globl styles
import './src/styles/global.css'